import "./index.scss";

import { Box, Stack } from "@mui/material";
import Button from "components/Button";
import ScreenLoader from "components/ScreenLoader";
import { Circuit } from "models/circuit";
import { getCircuitById } from "modules/circuit/circuitServices";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import CircuitCreateEditModal from "../CircuitCreateEditModal";

function CircuitView() {
  const [loading, setLoading] = useState(false);
  const [circuit, setCircuit] = useState<Circuit>();
  const [showEditModal, setShowEditModal] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    setLoading(true);
    getCircuitById({ id })
      .then((r) => {
        if (r.success) {
          setCircuit(r.data);
        }
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handleCloseModal = (isRefreshNeeded = false) => {
    setShowEditModal(false);
    if (typeof isRefreshNeeded == "boolean" && isRefreshNeeded) {
      setLoading(true);
      window.location.reload();
    }
  };

  if (loading) {
    return <ScreenLoader isScreenLoader={true} />;
  }

  return (
    <>
      <Stack className="manage-circuit-container">
        <Stack direction="row" justifyContent="space-between" gap={2} alignItems="center">
          <p className="circuit-title">{circuit?.title}</p>
          <Button className="edit-button" label="Edit" onClick={() => setShowEditModal(true)} />
        </Stack>
        <Stack flex={1} mt={4} className="details-container">
          <Stack direction="row" className="description">
            <label>Circuit Description</label>
            <p>{circuit?.description}</p>
          </Stack>
          <Box className="exercises">
            <p className="title">Exercises</p>
            <Stack className="items">
              {circuit?.exercises.map((e, index) => (
                <Box className="item" key={`circuit-exercise-${index}`}>
                  <p>{e.title}</p>
                </Box>
              ))}
            </Stack>
          </Box>
        </Stack>
      </Stack>
      <CircuitCreateEditModal
        open={showEditModal}
        onClose={handleCloseModal}
        entryId={parseInt(id)}
      />
    </>
  );
}

export default CircuitView;
